import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import {
    isDMINoTouchOrAfterTrial,
    isMcpNtOrTrialOrAfterTrial,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

const Badge = styled.div`
    ${setFontVariant("caption2", colorsPalettes.blue[400])};
    background-color: ${colorsPalettes.blue[100]};
    letter-spacing: 0.6px;
    border-radius: 16px;
    padding: 4px 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 16px;
`;
export const getUnlockBadge = () => {
    return isDMINoTouchOrAfterTrial(swSettings) && !isMcpNtOrTrialOrAfterTrial(swSettings) ? (
        <Badge>{translate("pro.side.bar.unlock.badge.component.test")}</Badge>
    ) : null;
};
